














import { Vue, Component, Prop } from "vue-property-decorator";

@Component({
  components: {
    "exchange-rates-component": () =>
      import("@/components/app/admin/settings/currencies/exchangeRatesComp.vue")
  }
})
export default class BrandCurrenciesSettings extends Vue {
  // Refs

  public $refs!: {
    exchangeRatesComponent: HTMLFormElement;
  };

  // Props

  @Prop({ default: false })
  public dynamicSettingsLoading!: boolean;

  // Life-cycle methods

  public created() {
    this.$emit("predefinedSettingsAreLoading", false);
  }

  // Methods

  public async save() {
    return this.$refs.exchangeRatesComponent.save();
  }

  public onChange(isChanged) {
    this.$emit("predefinedSettingsAreChanged", isChanged);
  }

  public onError(value) {
    this.$emit("predefinedSettingsHasErrors", value);
  }

  public revertToInitialState() {
    return this.$refs.exchangeRatesComponent.revertToInitialState();
  }
}
